import AuthorizationStore from './authorization'
import NotificationStore from './notification'

const stores = {
  AuthorizationStore,
  NotificationStore
}

export default stores
